export enum DateRangeType {
    ThreeMonths = 0,
    SixMonths = 1,
    OneYear = 2
}